import { useContext } from 'react';
import { RolesContext } from './roles-context';
export const useRoles = () => useContext(RolesContext);
